import { Spinner, Box } from '@chakra-ui/react';

import NoDisciplinaryActions from 'assets/assetsV1/illustrations/noDisciplinaryActions.svg';

import { EmptyScreen } from 'uiToolkitV1/EmptyScreen';
import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const ChartLoading = ({ width = '50%' }) => (
  <PaperWithShadow w={width} p={0} h="100%">
    <Box w="100%" h="100%" display="flex" justifyContent="center" alignItems="center">
      <Spinner size="md" color="##0D819F" />
      <TextBodyMedium ml="8px">Loading chart data...</TextBodyMedium>
    </Box>
  </PaperWithShadow>
);

export const ChartLoadingWithoutPaperShadow = ({ width = '50%' }) => (
  <Box w={width} h="100%" display="flex" justifyContent="center" alignItems="center">
    <Spinner size="md" color="##0D819F" />
    <TextBodyMedium ml="8px">Loading chart data...</TextBodyMedium>
  </Box>
);

export const ChartErrorScreen = ({ heading = 'Error loading chart data', width = '50%' }) => (
  <PaperWithShadow h="100%" w={width} p={4} mb={1} position="relative">
    <EmptyScreen heading={heading} illustrationSrc={NoDisciplinaryActions} />
  </PaperWithShadow>
);

export const ChartErrorScreenWithoutPaperShadow = ({ heading = 'Error loading chart data', width = '50%' }) => (
  <Box w={width} h="100%" display="flex" justifyContent="center" alignItems="center">
    <EmptyScreen heading={heading} illustrationSrc={NoDisciplinaryActions} />
  </Box>
);
